import React from "react";
import { Modal, ModalTitle, ModalBody, ModalFooter } from "@vds/modals";
import { Button } from "@vds/buttons";
import { Body } from "@vds/typography";
import { Icon } from "@vds/icons";
import { APPEARANCE_TEXT } from "../../../constants/enrolledAppearanceConstants";
import { DeployModalContainer, ModalCloseButton } from "../EAList/styles/ea-styles";

const CrossSiteWarningModal = ({ opened, onCancel, onEnroll, title, body }) => (
  <Modal
    id="cross-site-warning-modal"
    opened={opened}
    surface="light"
    disableOutsideClick={true}
    ariaLabel={title || APPEARANCE_TEXT.CROSS_SITE_WARNING_TITLE}
    hideCloseButton={true}
    closeButton={
      <ModalCloseButton onClick={onCancel}>
        <Icon name="close" />
      </ModalCloseButton>
    }
  >
    <ModalTitle>{title || APPEARANCE_TEXT.CROSS_SITE_WARNING_TITLE}</ModalTitle>
    <ModalBody>
      <Body size="large">{body || APPEARANCE_TEXT.CROSS_SITE_WARNING_BODY}</Body>
    </ModalBody>
    <ModalFooter>
      <DeployModalContainer>
        <Button size="large" use="secondary" onClick={onCancel}>
          {APPEARANCE_TEXT.CANCEL_BUTTON}
        </Button>
        <Button size="large" use="primary" onClick={onEnroll}>
          {APPEARANCE_TEXT.ENROLL_BUTTON}
        </Button>
      </DeployModalContainer>
    </ModalFooter>
  </Modal>
);

export default CrossSiteWarningModal;
